<p-toast key="credit-validation" position="top-right"></p-toast>

<p-card styleClass="validation-card">
  <div class="page-header">
    <div class="header-left">
      <a
        pButton
        class="p-button-text p-button-sm back"
        icon="pi pi-arrow-left"
        routerLink="/credit-history/validations"
        aria-label="Volver a la bandeja"
      ></a>
      <div>
        <h1>Validar formato de buró</h1>
        <p class="header-subtitle" *ngIf="detail">
          <a [routerLink]="['/customer', detail.client.id]" data-test="validation-client">{{ detail.client.name }}</a>
          · {{ detail.client.rfc }} · mandado por {{ detail.authorization.uploadedBy.name }} el
          {{ detail.authorization.createdAt | mxDate }}
        </p>
      </div>
    </div>
    <div class="header-right" *ngIf="status as s">
      <p-tag [severity]="s.severity" [icon]="s.icon" [value]="s.label" data-test="validation-status"></p-tag>
    </div>
  </div>

  <p-divider></p-divider>

  <div class="empty-state" *ngIf="loading && !detail" data-test="validation-loading">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    <span>Cargando la validación…</span>
  </div>

  <div class="empty-state is-error" *ngIf="loadError" role="alert" data-test="validation-error">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <h3>No pudimos cargar la validación</h3>
    <span>{{ loadError }}</span>
    <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-refresh" label="Reintentar" (click)="load()"></button>
  </div>

  <div class="validation-grid" *ngIf="detail && form && !loadError">
    <!-- El formato firmado: lo que se valida. -->
    <section class="pdf-pane" aria-label="Formato firmado">
      <app-pdf-viewer *ngIf="pdf" [blob]="pdf"></app-pdf-viewer>
      <div class="empty-state" *ngIf="!pdf && !pdfError">
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        <span>Cargando el PDF…</span>
      </div>
      <div class="empty-state is-error" *ngIf="pdfError" role="alert" data-test="validation-pdf-error">
        <i class="pi pi-file-excel" aria-hidden="true"></i>
        <span>{{ pdfError }}</span>
      </div>
    </section>

    <!-- Lo que Legal confirma contra el formato. -->
    <section class="form-pane" aria-label="Revisión del formato">
      <p class="note" *ngIf="isPending && !canValidate" data-test="validation-readonly">
        <i class="pi pi-lock" aria-hidden="true"></i>
        Solo Legal aprueba o rechaza. Lo ves en solo lectura.
      </p>
      <p class="note is-bad" *ngIf="detail.authorization.status === 'rejected'" data-test="validation-rejected">
        <i class="pi pi-times-circle" aria-hidden="true"></i>
        Rechazado por {{ detail.authorization.reviewedBy?.name }} el {{ detail.authorization.reviewedAt | mxDate }}: «{{
          detail.authorization.rejectionReason
        }}»
      </p>
      <p class="note is-good" *ngIf="detail.authorization.status === 'approved'" data-test="validation-approved">
        <i class="pi pi-check-circle" aria-hidden="true"></i>
        Aprobado por {{ detail.authorization.reviewedBy?.name }} el {{ detail.authorization.reviewedAt | mxDate }}. Vigente hasta el
        {{ detail.authorization.validUntil | slice: 0 : 10 | mxDate }}.
      </p>

      <fieldset [disabled]="!editable || saving" class="review-form">
        <div class="field">
          <span class="field-label" id="person-type-label">Tipo de persona que marca el formato</span>
          <div class="radio-row" role="radiogroup" aria-labelledby="person-type-label">
            <label *ngFor="let option of personTypes" class="radio">
              <input type="radio" name="personType" [value]="option.value" [(ngModel)]="form.personType" />
              {{ option.label }}
            </label>
          </div>
        </div>

        <div class="field-grid">
          <label class="field">
            <span class="field-label">Fecha de firma</span>
            <input pInputText type="date" name="signedAt" [(ngModel)]="form.signedAt" data-test="validation-signed-at" />
          </label>
          <label class="field">
            <span class="field-label">RFC</span>
            <input pInputText name="rfc" [(ngModel)]="form.rfc" maxlength="13" autocomplete="off" />
          </label>
          <label class="field full">
            <span class="field-label">{{ form.personType === 'PM' ? 'Razón social' : 'Nombre completo' }}</span>
            <input pInputText name="name" [(ngModel)]="form.name" maxlength="250" />
          </label>
          <label class="field full" *ngIf="form.personType === 'PM'">
            <span class="field-label">Representante legal (como viene en el formato)</span>
            <input
              pInputText
              name="legalRepresentative"
              [(ngModel)]="form.legalRepresentative"
              maxlength="250"
              data-test="validation-representative"
            />
          </label>
        </div>

        <div class="field-grid">
          <label class="field full">
            <span class="field-label">Calle y número</span>
            <input pInputText name="street" [(ngModel)]="form.street" maxlength="200" />
          </label>
          <label class="field">
            <span class="field-label">Colonia</span>
            <input pInputText name="neighborhood" [(ngModel)]="form.neighborhood" maxlength="120" />
          </label>
          <label class="field">
            <span class="field-label">Municipio o alcaldía</span>
            <input pInputText name="municipality" [(ngModel)]="form.municipality" maxlength="120" />
          </label>
          <label class="field">
            <span class="field-label">Ciudad</span>
            <input pInputText name="city" [(ngModel)]="form.city" maxlength="120" />
          </label>
          <label class="field">
            <span class="field-label">Código postal</span>
            <input pInputText name="postalCode" [(ngModel)]="form.postalCode" maxlength="5" inputmode="numeric" />
          </label>
          <label class="field full">
            <span class="field-label">Estado (catálogo de Círculo)</span>
            <select class="p-inputtext" name="stateCode" [(ngModel)]="form.stateCode" data-test="validation-state">
              <option [ngValue]="null">Elige el estado</option>
              <option *ngFor="let state of detail.states" [ngValue]="state.code">{{ state.name }} ({{ state.code }})</option>
            </select>
            <small class="hint" *ngIf="detail.prefill.address.stateText"
              >En la ficha: «{{ detail.prefill.address.stateText }}»{{
                detail.prefill.address.stateCode ? '' : ', sin clave reconocida'
              }}</small
            >
          </label>
        </div>

        <div class="field">
          <span class="field-label">Lista de verificación</span>
          <label *ngFor="let item of checks; trackBy: trackByIndex" class="check" data-test="validation-check">
            <input type="checkbox" [name]="'check-' + item.code" [(ngModel)]="form.checks[item.code]" />
            {{ item.label }}
          </label>
        </div>
      </fieldset>

      <ng-container *ngIf="editable">
        <p class="missing" *ngIf="missingForApproval.length" data-test="validation-missing">
          Para aprobar falta: {{ missingForApproval.join(', ') }}.
        </p>

        <div class="reject-box" *ngIf="rejecting">
          <label class="field">
            <span class="field-label">Motivo del rechazo (mínimo {{ reasonMin }} caracteres)</span>
            <textarea
              pInputTextarea
              rows="3"
              name="rejectionReason"
              [(ngModel)]="rejectionReason"
              [disabled]="saving"
              data-test="validation-reason"
            ></textarea>
          </label>
        </div>

        <div class="decision">
          <ng-container *ngIf="!rejecting; else rejectActions">
            <button
              pButton
              type="button"
              class="p-button-outlined p-button-danger"
              icon="pi pi-times"
              label="Rechazar"
              [disabled]="saving"
              (click)="rejecting = true"
              data-test="validation-start-reject"
            ></button>
            <button
              pButton
              type="button"
              icon="pi pi-check"
              label="Aprobar"
              [disabled]="saving || missingForApproval.length > 0"
              (click)="approve()"
              data-test="validation-approve"
            ></button>
          </ng-container>
          <ng-template #rejectActions>
            <button
              pButton
              type="button"
              class="p-button-outlined"
              label="Cancelar"
              [disabled]="saving"
              (click)="rejecting = false"
            ></button>
            <button
              pButton
              type="button"
              class="p-button-danger"
              icon="pi pi-times"
              label="Rechazar formato"
              [disabled]="saving || rejectionReason.trim().length < reasonMin"
              (click)="reject()"
              data-test="validation-reject"
            ></button>
          </ng-template>
        </div>
      </ng-container>

      <div class="history" *ngIf="detail.authorization.history.length">
        <span class="field-label">Movimientos</span>
        <ul>
          <li *ngFor="let event of detail.authorization.history; trackBy: trackByIndex">
            {{ actionLabels[event.action] }} · {{ event.at | mxDate
            }}<ng-container *ngIf="event.byName"> · {{ event.byName }}</ng-container>
          </li>
        </ul>
      </div>
    </section>
  </div>
</p-card>
